<template>
  <div
    class="landing-page__banner-and-background"
    :style="`background-image: url(${
      backgroundImage || ''
    });background-repeat:no-repeat;background-size: cover;`"
  >
    <div class="banner" v-if="transformedBanner">
      <sib-link
        :to="transformedBanner.link"
        :title="transformedBanner.title"
        class="banner__item"
      >
        <sib-image v-bind="transformedBanner.image"></sib-image>
      </sib-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useDeviceStore from '@/store/device'
const deviceStore = useDeviceStore()

let props = withDefaults(defineProps<{ section: any }>(), {})

const backgroundImage = computed(() => {
  return deviceStore.isMobile
    ? props.section?.backgroundImageMobile
    : props.section?.backgroundImageDesktop
})

const transformedBanner = computed(() => {
  return {
    image: {
      src: props.section?.bannerDesktop,
      alt: props.section.title || '',
      width: 3573,
      height: 1181,
      sources: [
        {
          size: 330,
          src: props.section?.bannerMobile,
          width: 450,
        },
        {
          size: 420,
          media: 361,
          src: props.section?.bannerMobile,
          width: 450,
        },
        {
          size: 740,
          media: 450,
          src: props.section?.bannerMobile,
          width: 3573,
          height: 1181,
        },
        {
          size: 1010,
          media: 768,
          src: props.section?.bannerDesktop,
          width: 3573,
          height: 1181,
        },
        {
          size: 1120,
          media: 1200,
          src: props.section?.bannerDesktop,
          width: 3573,
          height: 1181,
        },
        {
          media: 1400,
          src: props.section?.bannerDesktop,
          width: 3573,
          height: 1181,
        },
      ],
    },
    link: props.section.link,
    title: props.section.title || '',
  }
})
</script>

<style lang="scss">
.landing-page__banner-and-background {
}
</style>
